import {
  FAVOURITE_ADDED,
  FAVOURITE_REMOVED,
  FAVOURITE_REMOVE_SUCCESS,
  FAVOURITE_SELECTED,
  FAVOURITE_OLD_SELECTED,
  FAVOURITE_ADD_SUCCESS,
  FAVOURITE_UPDATE_SUCCESS,
  FAVOURITES_FETCH_FAILED,
  FAVOURITE_ADD_FAILED,
  FAVOURITE_REMOVE_FAILED,
  FAVOURITE_UPDATE_FAILED
} from './favourite.action';

// GTM-UPDATE
const addToDataLayer = data => window.dataLayer.push(data);


const favouriteClicked = () => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-clicked'
});

const favouriteAdded = () => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-added'
});

const favouriteRemoved = () => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-removed'
});

// const favouriteRemovedSuccess = () => ({
//   hitType: 'event',
//   eventCategory: 'asset-search',
//   eventAction: 'favourite-removed-success'
// });

const favouriteOldSelected = () => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'old-favourite-clicked'
});

const favouriteSavedSuccess = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-saved-success',
  eventLabel: JSON.stringify(action.payload)
});

// const favouriteUpdatedSuccess = action => ({
//   hitType: 'event',
//   eventCategory: 'asset-search',
//   eventAction: 'favourite-updated-success',
//   eventLabel: JSON.stringify(action.payload)
// });

const favouriteSavedFailed = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-saved-failed',
  eventLabel: JSON.stringify(action.payload)
});

const favouriteUpdatedFailed = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-updated-failed',
  eventLabel: JSON.stringify(action.payload)
});

const favouriteRemovedFailed = action => ({
  hitType: 'event',
  eventCategory: 'asset-search',
  eventAction: 'favourite-removed-failed',
  eventLabel: JSON.stringify(action.payload)
});

// const favouritefetchFailed = action => ({
//   hitType: 'event',
//   eventCategory: 'asset-search',
//   eventAction: 'favourite-fetch-failed',
//   eventLabel: JSON.stringify(action.payload)
// });

export const FavouriteAnalytics = {
  [FAVOURITE_SELECTED]: favouriteClicked,
  [FAVOURITE_REMOVED]: favouriteRemoved,
  [FAVOURITE_ADDED]: favouriteAdded,
  [FAVOURITE_OLD_SELECTED]: favouriteOldSelected,
  [FAVOURITE_ADD_SUCCESS]: favouriteSavedSuccess,
  // [FAVOURITE_UPDATE_SUCCESS]: favouriteUpdatedSuccess,
  [FAVOURITE_UPDATE_SUCCESS]: action => addToDataLayer({
    event: 'favoriteUpdated',
    data: action.payload
  }),
  // [FAVOURITE_REMOVE_SUCCESS]: favouriteRemovedSuccess,
  [FAVOURITE_REMOVE_SUCCESS]: action => addToDataLayer({
    event: 'favoriteRemoved',
    data: action.payload
  }),
  [FAVOURITE_ADD_FAILED]: favouriteSavedFailed,
  [FAVOURITE_UPDATE_FAILED]: favouriteUpdatedFailed,
  [FAVOURITE_REMOVE_FAILED]: favouriteRemovedFailed,
  // [FAVOURITES_FETCH_FAILED]: favouritefetchFailed,

  [FAVOURITES_FETCH_FAILED]: action => addToDataLayer({
    event: 'failure',
    data: action.payload
  })
};
